
import React from "react";
import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function CasosExitoSection() {
  return (
    <PostSection id="casos-exito" title="Casos de éxito y ejemplos destacables">
      <PostHighlight type="tip">
        Plataformas como Amazon y Zalando han mejorado constantemente sus fichas de producto mediante el uso de imágenes de alta calidad, descripciones detalladas y sistemas de recomendación personalizados.
      </PostHighlight>
    </PostSection>
  );
}
